<template>
    <div>
        <!-- FASE 4 / BLOCO AC — DOC 13, 15, 51, 52, 53 -->

        <el-row class="u-mt-10 u-mb-15">
            <el-col :xs="24" :sm="16">
                <el-alert type="info" :closable="false" show-icon
                          title="O fluxo define quem aprova o documento, e em que ordem."
                          description="As aprovações seguem a ordem das etapas: a próxima só é liberada quando a anterior é decidida.">
                </el-alert>
            </el-col>
            <el-col :xs="24" :sm="8" class="u-text-right">
                <el-button type="primary" icon="el-icon-plus" @click="abrir(null)">NOVO FLUXO</el-button>
            </el-col>
        </el-row>

        <div class="container-table" v-loading="!statusList">
            <table class="table table-striped">
                <thead>
                    <tr><th>Nome</th><th class="hidden-mobile">Descrição</th>
                        <th class="u-text-center" style="width:90px">Ativo</th>
                        <th class="u-text-center" style="width:170px">Ação</th></tr>
                </thead>
                <tbody>
                    <tr v-for="f in items" :key="f.id">
                        <td>{{ f.nome }}</td>
                        <td class="hidden-mobile meta">{{ f.descricao | truncate(70, '...') }}</td>
                        <td class="u-text-center">
                            <!-- DOC 53 -->
                            <el-switch :value="!!f.ativo" @change="v => definirAtivo(f, v)"></el-switch>
                        </td>
                        <td class="u-text-center acao">
                            <el-button type="info" icon="el-icon-view" size="mini" plain
                                       title="Ver etapas" @click="verEtapas(f)"></el-button>
                            <el-button class="u-ml-10" type="primary" icon="el-icon-edit" size="mini" plain
                                       title="Editar" @click="abrir(f)"></el-button>
                            <el-button class="u-ml-10" type="danger" icon="el-icon-delete" size="mini" plain
                                       title="Excluir" @click="excluir(f)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length && statusList">
                        <td colspan="4" class="u-text-center">Nenhum fluxo cadastrado.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- DOC 13, 14, 52 -->
        <el-dialog :title="form.id ? 'Editar fluxo' : 'Novo fluxo de trabalho'"
                   :visible.sync="dialogForm" width="720px">
            <el-form label-position="top" class="u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome"><el-input v-model="form.nome" maxlength="150"></el-input></el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Descrição"><el-input v-model="form.descricao" maxlength="2000"></el-input></el-form-item>
                    </el-col>
                </el-row>

                <el-divider content-position="left">Etapas — na ordem em que serão aprovadas</el-divider>

                <div v-for="(e, i) in form.etapas" :key="i" class="etapa">
                    <el-row :gutter="10">
                        <el-col :xs="2" class="u-text-center ordem">{{ i + 1 }}</el-col>
                        <el-col :xs="22" :sm="7">
                            <el-input v-model="e.nome" placeholder="Nome da etapa" maxlength="150"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="7">
                            <el-select v-model="e.user_id_responsavel" filterable remote
                                       :remote-method="buscarUsuarios" :loading="buscando"
                                       placeholder="Responsável pela aprovação" style="width:100%">
                                <el-option v-for="u in usuarios" :key="u.id" :label="u.name" :value="u.id"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="6">
                            <!-- DOC 14 -->
                            <el-input v-model="e.descricao_atividade" maxlength="500"
                                      placeholder="Ex.: analisar, aprovar"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="2" class="u-text-right">
                            <el-button type="danger" icon="el-icon-delete" size="mini" plain
                                       @click="form.etapas.splice(i, 1)"></el-button>
                        </el-col>
                    </el-row>
                </div>

                <el-button type="text" icon="el-icon-plus" @click="adicionarEtapa">adicionar etapa</el-button>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogForm = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" @click="salvar">SALVAR</el-button>
            </span>
        </el-dialog>

        <!-- DOC 15 -->
        <el-dialog :title="'Etapas — ' + (detalhe.fluxo ? detalhe.fluxo.nome : '')"
                   :visible.sync="dialogEtapas" width="620px">
            <table class="table table-striped">
                <thead>
                    <tr><th style="width:60px" class="u-text-center">Ordem</th><th>Etapa</th>
                        <th>Responsável</th><th>Atribuição</th></tr>
                </thead>
                <tbody>
                    <tr v-for="e in detalhe.etapas" :key="e.id">
                        <td class="u-text-center">{{ e.ordem }}</td>
                        <td>{{ e.nome }}</td>
                        <td>{{ e.responsavel }}</td>
                        <td class="meta">{{ e.descricao_atividade || '—' }}</td>
                    </tr>
                </tbody>
            </table>
        </el-dialog>
    </div>
</template>
<script>

export default {
    data: () => ({
        statusList: false,
        items: [],
        usuarios: [],
        buscando: false,
        dialogForm: false,
        form: { id: null, nome: '', descricao: '', etapas: [] },
        dialogEtapas: false,
        detalhe: { fluxo: null, etapas: [] }
    }),
    mounted () { this.carregar() },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        instituicaoAtual () {
            const i = this.$store.state.config.instituicao
            return i ? i.id : null
        },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const d = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (d && typeof d.erro === 'string') msg = d.erro
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        carregar () {
            this.statusList = false
            this.$axios.post(`${this.base()}/api/documento-fluxo/getAllPaginate`, {}, this.auth())
                .then(r => { this.items = r.data.data; this.statusList = true })
                .catch(e => { this.statusList = true; this.erro(e) })
        },

        buscarUsuarios (termo) {
            if (!termo || termo.length < 2) return
            this.buscando = true
            // Reusa o seletor de destinos do compartilhamento: mesma regra de elegibilidade.
            this.$axios.post(`${this.base()}/api/documento-gestao/transferencia/usuarios`,
                { termo: termo, instituicao_id: this.instituicaoAtual() }, this.auth()).then(r => {
                this.usuarios = r.data
                this.buscando = false
            }).catch(e => { this.buscando = false; this.erro(e) })
        },

        adicionarEtapa () {
            this.form.etapas.push({ nome: '', user_id_responsavel: '', descricao_atividade: '' })
        },

        abrir (f) {
            if (!f) {
                this.form = { id: null, nome: '', descricao: '', etapas: [] }
                this.adicionarEtapa()
                this.dialogForm = true
                return
            }

            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.base()}/api/documento-fluxo/getById/${f.id}`, this.auth()).then(r => {
                window.eventBus.$emit('loading', false)
                this.form = {
                    id: r.data.fluxo.id, nome: r.data.fluxo.nome, descricao: r.data.fluxo.descricao || '',
                    etapas: r.data.etapas.map(e => ({
                        nome: e.nome, user_id_responsavel: e.user_id_responsavel,
                        descricao_atividade: e.descricao_atividade || ''
                    }))
                }
                // O seletor precisa conhecer os nomes de quem já é responsável.
                this.usuarios = r.data.etapas.map(e => ({ id: e.user_id_responsavel, name: e.responsavel }))
                this.dialogForm = true
            }).catch(e => { this.erro(e) })
        },

        salvar () {
            const payload = {
                nome: this.form.nome, descricao: this.form.descricao, etapas: this.form.etapas
            }
            if (!this.form.id) payload.instituicao_id = this.instituicaoAtual()

            const url = this.form.id
                ? `${this.base()}/api/documento-fluxo/update/${this.form.id}`
                : `${this.base()}/api/documento-fluxo/store`

            window.eventBus.$emit('loading', true)
            this.$axios.post(url, payload, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                this.dialogForm = false
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        definirAtivo (f, ativo) {
            this.$axios.post(`${this.base()}/api/documento-fluxo/definir-ativo/${f.id}`,
                { ativo: ativo }, this.auth()).then(() => {
                window.eventBus.$emit('alert', {
                    msg: ativo ? 'Fluxo habilitado.' : 'Fluxo desabilitado.', type: 'success'
                })
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        verEtapas (f) {
            this.$axios.get(`${this.base()}/api/documento-fluxo/getById/${f.id}`, this.auth()).then(r => {
                this.detalhe = r.data
                this.dialogEtapas = true
            }).catch(e => { this.erro(e) })
        },

        excluir (f) {
            this.$msgbox.confirm(
                'Excluir este fluxo? Se ele já foi usado em documentos, será apenas desabilitado.',
                'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.base()}/api/documento-fluxo/remover/${f.id}`, this.auth())
                    .then(r => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', {
                            msg: r.data.inativado ? r.data.mensagem : 'Sucesso! - Fluxo excluído.', type: 'success'
                        })
                        this.carregar()
                    }).catch(e => { this.erro(e) })
            }).catch(() => {})
        }
    }
}
</script>
<style scoped>
.meta  { font-size: 12px; color: #909399; }
.etapa { border-bottom: 1px dashed #EBEEF5; padding: 6px 0; }
.ordem { font-weight: 600; color: #909399; padding-top: 8px; }
</style>
